module.exports = __webpack_public_path__ + "static/media/background-primary.d36e04a0.svg";